import { selectIsFetching as selectIsFetchingPlan } from './state/plan/selector'
import { selectIsFetching as selectIsFetchingProcess, selectIsFetching as selectIsFetchingQuoatation } from './state/quotation/selector'
import { selectIsFetching as selectIsFetchingReassign } from './state/reassign/selector'


export default {
    action: {},
    selector: {
        selectIsFetching: (state) => {
            return selectIsFetchingPlan(state) ||
                selectIsFetchingProcess(state) ||
                selectIsFetchingQuoatation(state) ||
                selectIsFetchingReassign(state)
        },
    },
}




// WEBPACK FOOTER //
// ./src/modules/treatment/index.js